export const CONSENT_VERSION = 1
export const CONSENT_STORAGE_KEY = 'mConf_cookieConsent'
export const LEGACY_CONSENT_STORAGE_KEY = 'vue-cookie-accept-decline-cookieNotice'

const OPTIONAL_COOKIE_PATTERNS = [
  /^_pk_/,
  /^mtm_/,
  /^_ga(?:_|$)/,
  /^_gid$/,
  /^_gat(?:_|$)/,
  /^_gac_/,
  /^__hstc$/,
  /^__hssc$/,
  /^__hssrc$/,
  /^hubspotutk$/,
  /^messagesUtk$/
]

export function parseConsent (value) {
  if (typeof value !== 'string') {
    return null
  }

  try {
    const consent = JSON.parse(value)
    if (
      !consent ||
      typeof consent !== 'object' ||
      consent.version !== CONSENT_VERSION ||
      typeof consent.optional !== 'boolean'
    ) {
      return null
    }

    return {
      version: CONSENT_VERSION,
      optional: consent.optional
    }
  } catch (error) {
    return null
  }
}

function getStorage (storage) {
  if (storage) {
    return storage
  }

  if (typeof window === 'undefined') {
    return null
  }

  return window.localStorage
}

export function prepareConsentStorage (storage) {
  const target = getStorage(storage)
  if (!target) {
    return null
  }

  try {
    target.removeItem(LEGACY_CONSENT_STORAGE_KEY)
  } catch (error) {
    return null
  }

  return readConsent(target)
}

export function readConsent (storage) {
  const target = getStorage(storage)
  if (!target) {
    return null
  }

  try {
    return parseConsent(target.getItem(CONSENT_STORAGE_KEY))
  } catch (error) {
    return null
  }
}

export function saveConsent (optional, storage) {
  const target = getStorage(storage)
  const consent = {
    version: CONSENT_VERSION,
    optional: Boolean(optional)
  }

  if (!target) {
    return consent
  }

  try {
    target.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent))
  } catch (error) {
    // Runtime consent still applies when storage is unavailable.
  }

  return consent
}

export function hasOptionalConsent (consent = readConsent()) {
  return Boolean(consent && consent.optional)
}

export function isOptionalCookieName (name) {
  return OPTIONAL_COOKIE_PATTERNS.some(pattern => pattern.test(name))
}

export function deleteOptionalCookies (targetDocument, targetLocation) {
  const doc = targetDocument || (typeof document !== 'undefined' ? document : null)
  const location = targetLocation || (typeof window !== 'undefined' ? window.location : null)

  if (!doc || !location) {
    return []
  }

  const cookieNames = doc.cookie
    .split(';')
    .map(cookie => cookie.split('=')[0].trim())
    .filter(name => name && isOptionalCookieName(name))

  const domains = ['', location.hostname]
  if (location.hostname === 'mesimedical.com' || location.hostname.endsWith('.mesimedical.com')) {
    domains.push('.mesimedical.com')
  }

  cookieNames.forEach((name) => {
    domains.forEach((domain) => {
      const domainAttribute = domain ? `; domain=${domain}` : ''
      doc.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainAttribute}; SameSite=Lax`
    })
  })

  return cookieNames
}
